module.exports = __webpack_public_path__ + "static/media/html_structure.b9be353f.png";